import React, { useState, useCallback } from 'react';
import './Hero.css';
import useRevealOnScroll from '../utils/useRevealOnScroll';
import useTypewriter from '../utils/useTypewriter';
import useMediaQuery from '../hooks/useMediaQuery';

const Hero = () => {
  const { ref, isVisible } = useRevealOnScroll();
  const [currentImage, setCurrentImage] = useState('Hero.png');
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  const { text } = useTypewriter({
    words: ['Scan in Seconds', 'Browse Beautifully', 'Order Faster'],
    typeMs: 60,
    deleteMs: 40,
    pauseMs: 1200
  });

  const toggleImage = useCallback(() => {
    if (isMobile) {
      setCurrentImage(prev => prev === 'Hero.png' ? 'Hero2.png' : 'Hero.png');
    }
  }, [isMobile]);

  const handleHover = useCallback((isHovering) => {
    if (!isMobile) {
      setCurrentImage(isHovering ? 'Hero2.png' : 'Hero.png');
    }
  }, [isMobile]);

  return (
    <section className={isVisible ? 'hero reveal isVisible' : 'hero reveal'} id="top" ref={ref}>
      <div className="heroContainer">
        <div className="heroContent">
          <div className="heroText">
            <div className="santas-container" style={{
              position: 'relative',
              top: isMobile ? '20px' : '0',
              left: isMobile ? '50%' : '2%',
              transform: isMobile ? 'translateX(-50%)' : 'none',
              zIndex: 3,
              width: isMobile ? '160px' : '200px',
              marginBottom: isMobile ? '20px' : '0',
              textAlign: 'center'
            }}>
              <img 
                src="/merry.png" 
                alt="Holiday Santas" 
                style={{
                  width: '100%',
                  height: 'auto',
                  filter: 'drop-shadow(0 10px 15px rgba(0, 0, 0, 0.1))',
                  pointerEvents: 'none',
                  display: 'block'
                }}
              />
            </div>
            <div className="heroBadge">
              <span className="badgeIcon">✨</span>
              Scan • Browse • Enjoy
            </div>
            
            <h1 className="heroHeading">
              A Premium Menu Experience —{' '}
              <span className="heroTypewriter" aria-label={text}>
                {text}
                <span className="typeCursor" aria-hidden="true">|</span>
              </span>
            </h1>
            
            <p className="heroDescription">
              Transform your dining experience with our modern digital menu platform. 
              Perfect for restaurants and delightful for customers.
            </p>

            <div className="heroButtons">
              <button 
                type="button" 
                className="heroBtn heroBtnPrimary"
                onClick={(e) => {
                  e.preventDefault();
                  const scrollToRolePicker = () => {
                    const element = document.getElementById('choose');
                    if (element) {
                      const headerOffset = 100; // Adjust this value based on your header height
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                      
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                      });
                    } else {
                      // If element not found, try again after a short delay
                      setTimeout(scrollToRolePicker, 100);
                    }
                  };
                  // Initial scroll attempt
                  scrollToRolePicker();
                }}
              >
                Get Started
              </button>
              <button 
                type="button" 
                className="heroBtn heroBtnSecondary"
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById('services');
                  if (element) {
                    window.scrollTo({
                      top: element.offsetTop - 80,
                      behavior: 'smooth'
                    });
                  }
                }}
              >
                Learn More
              </button>
            </div>
          </div>

          <div className="heroVisual">
            <div 
              className="heroImageWrapper"
              onMouseEnter={() => handleHover(true)}
              onMouseLeave={() => handleHover(false)}
              onClick={toggleImage}
              style={{ position: 'relative', zIndex: 2 }}
            >
              <img 
                src={`/${currentImage}`} 
                alt="Menu Bazaar - Digital menu experience illustration" 
                className="heroImage"
              />
              <div className="heroImageGlow"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
